// Soyalp Kargo (Webpostman) REST API sağlayıcısı.
// Döküman: Soyalp Kargo 3434Paneli.pdf — Soyalp, FEST ve Deposel ile AYNI Webpostman altyapısını
// kullanır. Endpoint'ler (consignment/add, edit, delete, tracking, cargo), kimlik doğrulama
// (Authorization + From header), form-urlencoded gövde, statü kodları (00-60) ve durum kovaları
// (0-6) birebir aynıdır. Tek fark taban URL'dir; kargo firması/şube kodları cari başına UI'dan
// girilir (veri farkı, kod farkı değil).
import { createWebpostmanProvider } from './webpostman'

const SOYALP_BASE = 'https://webpostman.soyalpcargo.com/restapi/client'

export const soyalpProvider = createWebpostmanProvider('soyalp', SOYALP_BASE)
